module.exports = __webpack_public_path__ + "static/media/tw.87feee67.svg";